import { render, staticRenderFns } from "./SSOManagement.vue?vue&type=template&id=cf8d1426&scoped=true"
import script from "./SSOManagement.vue?vue&type=script&lang=js"
export * from "./SSOManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8d1426",
  null
  
)

export default component.exports